import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RestApiService } from "./rest-api.service";
import { AuthService } from "./auth.service";
import { environment } from "src/environments/environment";
import { ContractedCompany } from "src/models/contracted-company";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ContractedCompanyService extends RestApiService {

  private _urlContractedCompanies = '/contracted-companies';
  private _urlContractedCompany = '/contracted-companies/:companyId';

  environmentEndpoint = environment.endpoint();

  constructor(
    private _http: HttpClient,
    private _auth: AuthService,
  ) {
    super(_http);
  }

  get reqHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this._auth.getJwtToken()}`,
    });
  }

  private buildUrl(path: string): string {
    const base = (this.environmentEndpoint || '').replace(/\/+$/, '');
    const p = (path || '').startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
  }

  // GET
  getContractedCompanies(params?: { limit?: number; offset?: number; search?: string }): Observable<any> {
    let query = '';

    if (params) {
      const q: string[] = [];
      if (params.limit != null) q.push(`limit=${params.limit}`);
      if (params.offset != null) q.push(`offset=${params.offset}`);
      if (params.search) q.push(`search=${encodeURIComponent(params.search)}`);
      if (q.length) query = `?${q.join('&')}`;
    }

    const url = this.buildUrl(this._urlContractedCompanies + query);
    return this._http.get(url, { headers: this.reqHeaders });
  }

  // POST
  createContractedCompany(payload: ContractedCompany): Observable<any> {
    const url = this.buildUrl(this._urlContractedCompanies);
    return this._http.post(url, payload, { headers: this.reqHeaders });
  }

  // PATCH
  patchContractedCompany(companyId: string, patch: Partial<ContractedCompany>): Observable<any> {
    const path = this._urlContractedCompany.replace(':companyId', companyId);
    const url = this.buildUrl(path);
    return this._http.patch(url, patch, { headers: this.reqHeaders });
  }

  deleteContractedCompany(companyId: string): Observable<any> {
    const path = this._urlContractedCompany.replace(':companyId', companyId);
    const url = this.buildUrl(path);
    return this._http.delete(url, { headers: this.reqHeaders });
  }

  getContractedCompanyMembers(companyId: string): Observable<any> {
    const url = this.buildUrl(`${this._urlContractedCompanies}/${companyId}/members`);
    return this._http.get(url, { headers: this.reqHeaders });
  }

  addContractedCompanyMember(companyId: string, payload: { memberId: string; duty: string }): Observable<any> {
    const url = this.buildUrl(`${this._urlContractedCompanies}/${companyId}/members`);
    return this._http.post(url, payload, { headers: this.reqHeaders });
  }

  removeContractedCompanyMember(companyId: string, memberId: string): Observable<any> {
    const url = this.buildUrl(`${this._urlContractedCompanies}/${companyId}/members/${memberId}`);
    return this._http.delete(url, { headers: this.reqHeaders });
  }

  getContractedCompanyById(companyId: string): Observable<any> {
    const path = this._urlContractedCompany.replace(':companyId', companyId);
    const url = this.buildUrl(path);
    return this._http.get(url, { headers: this.reqHeaders });
  }
}
